import { useSelector } from 'react-redux';
import { dataSelector } from '@nextiva/global-store';
import { useQuery } from '@tanstack/react-query';
import { getUseCases } from 'services';
import { UseCaseMap } from 'interface/WizardV3';

export const useGetUseCases = () => {
  const globalStoreData = useSelector(dataSelector);
  const corpAcctNumber = globalStoreData.user?.profileDTO?.corpAcctNbr;
  const enabled = !!corpAcctNumber;
  const validSubUsecase = 'true';

  return useQuery(['getUseCases'], {
    queryFn: () => getUseCases(corpAcctNumber, validSubUsecase),
    enabled,
    select: (data) => {
      const sortedUseCaseMap = Object.fromEntries(
        Object.entries(data.useCaseMap).sort(([keyA], [keyB]) =>
          keyA.localeCompare(keyB),
        ),
      );
      const useCaseMap: UseCaseMap = Object.entries(sortedUseCaseMap).reduce(
        (acc, [key, value], currentIndex) => {
          if (key === 'LOW_VOLUME') {
            return acc;
          }
          const { description, displayName } = value;
          acc[key] = { description, displayName, currentIndex };
          return acc;
        },
        {},
      );
      const firstUseCases: UseCaseMap = Object.fromEntries(
        Object.entries(useCaseMap).slice(0, 5),
      );
      const lastUseCases: UseCaseMap = Object.fromEntries(
        Object.entries(useCaseMap).slice(5, 10),
      );
      return {
        firstUseCases,
        lastUseCases,
      };
    },
  });
};
